import React from 'react';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';

const renderContent = (item: string) => (
    <Typography key={item}
                variant="body2">
        {item}
    </Typography>
);

type Props = {
    content: Array<string>,
    header: string | Function,
    IconComponent: React.ElementType,
};

const SummaryPanelDataBox: React.FC<Props> = ({
    content,
    header,
    IconComponent,
}) => {
    const [ contentHeader, ...restContent ] = content;

    const properHeader = typeof header === 'string'
        ? (
            <Typography variant="h5">
                <Box display="flex">
                    <Box mr={1}
                         component={IconComponent} />
                    {header}
                </Box>
            </Typography>
        )
        : header();

    return (
        <>
            {properHeader}
            <Divider />
            <Box mt={2}>
                <Typography variant="body1">
                    {contentHeader}
                </Typography>
                {restContent.map(renderContent)}
            </Box>
        </>
    );
};

export default SummaryPanelDataBox;
